
export interface GrupoInterface {
  buscaPlaca: number | string | null;
  usaChecklist: number | string | null;
  alterarValor: string | null;
  formularioDeRecepcao: string | null;
  utilizaMO: string | null;
  oleoFracionado: string | null;
  podeDesconto: string | null;
  assinaturaDoCliente: string | null;
  vendaEstoqueNegativo: string | null;
//   fornecedorBuscaPlaca: string
}

import { ref, onMounted, onUnmounted, defineEmits, watch, Ref } from "vue";
import { defineComponent } from "vue";
import useEmitter from "@/composables/Emmiter";
import Api from "../../services/Api";
import s3 from '../../services/S3Service'
import useAlert from "../../composables/Alert";
import { Modal } from "bootstrap";
import ModalGrupo from "./components/ModalGrupo.vue";
import { useRouter } from "vue-router";

export default defineComponent({

  name: "Grupos",
  
  components: {
    ModalGrupo,
  },

  setup() {
    const emitter = useEmitter();

    const grupoModal: Ref<any> = ref()
    const grupoSelecionado: Ref<any> = ref()
    const router = useRouter()

    const limite = ref(30);
    const pagina: Ref<any> = ref(null);

    const filtro: Ref<any> = ref({ loja: [], automocao: [], comErro: null });

    const loadGrupo: Ref<boolean> = ref(false);

    const arrayGrupo: Ref<any> = ref([]);
    const skeleton: Ref<boolean> = ref(false)
    




      // ATUALIZA LISTA DE GRUPO

    emitter.on("atualizaGrupo", (valor: any) => {

      const index = arrayGrupo.value.findIndex(({codGrupo}) => codGrupo === valor.grupo.codGrupo)

      if(index !== -1) arrayGrupo.value[index] = { ...valor.grupo }
      else arrayGrupo.value.unshift({ ...valor.grupo })

    })

    emitter.on("removeGrupo", (valor: any) => {

      const index = arrayGrupo.value.findIndex(({codGrupo}) => codGrupo === valor.grupo.codGrupo)

      if(index !== -1) arrayGrupo.value.splice(index,1)

    })
















    async function buscaGruposPaginado(paginaParam: number, filtrou: boolean = false) {

      try {
        const sectionLoadGrupo = document.getElementById('load'); //Variável da section do rodapé com o botão de Carregar Mais
        const loadGrupoButton = document.getElementById('loadGrupoButton'); //Variável da div do botão com o método buscaGrupoPaginado
        if(paginaParam == 1){
          //Habilita o skeleton
          skeleton.value = true;

          //Oculta o botão de Carregar Mais
          if(loadGrupoButton?.classList.contains('d-flex')) loadGrupoButton?.classList.remove('d-flex');
          loadGrupoButton?.classList.add('d-none');
        }
        
        loadGrupo.value = true;
  
        const { data } = await Api.get("grupoPaginado", { pagina: paginaParam, limite: limite.value, ...filtro.value });
        
        console.log(data);
        

        loadGrupo.value = false;

        if(paginaParam == 1){
          //Habilita o skeleton
          skeleton.value = false;

          //Reexibe o botão de Carregar Mais
          if(loadGrupo.value == false) loadGrupoButton?.classList.replace('d-none', 'd-flex');
        }
  
        pagina.value = paginaParam;
  
        if(filtrou) arrayGrupo.value = [];
  
        arrayGrupo.value = [ ...arrayGrupo.value, ...data.grupos ];

        //Verifica se a quantidade de resultados encontrados é menor que o limite da página
        if(arrayGrupo.value.length < limite.value || data.grupos.length === 0) {
          //Se for menor, oculta toda a section para evitar mais requisições a api 
          sectionLoadGrupo?.classList.replace('d-flex', 'd-none');
        } else {
          sectionLoadGrupo?.classList.replace('d-none', 'd-flex');
        } 
      } catch (error) { loadGrupo.value = false; }

    }


    emitter.on("FilterGrupos", (props: any) => {

      filtro.value = props

      buscaGruposPaginado(1, true);

    });

    async function redirectToEdit(idGrupo: number | null){
      await router.push({name:'editarGrupos', query: { idGrupo: idGrupo }})
    };


    ///////////////////// MODAL PRODUTO LOG /////////////////////

    function abreModal(grupo?) {

      grupoSelecionado.value = grupo || {}
      grupoModal.value.show()

    }

    async function fechaModal() {
      
      grupoSelecionado.value = {}
      grupoModal.value.hide()

    }

    ///////////////////// MODAL PRODUTO LOG /////////////////////


    onMounted(() => {

      grupoModal.value = new Modal(document.querySelector(`#ModalGrupo`));

      const observer = new IntersectionObserver(entries => {
        if(entries[0].isIntersecting) buscaGruposPaginado(pagina.value ? pagina.value + 1 : 1);
      }).observe(document.querySelector("#load") as any);

    })




    return {

      arrayGrupo,
      loadGrupo,
      buscaGruposPaginado,
      pagina,
      abreModal,
      fechaModal,
      grupoSelecionado,
      history,
      redirectToEdit,
      router,
      limite,
      skeleton
    }



  }

});
